import React, { useState } from "react";
import { Button, Card, CardBody, CardText, CardTitle } from "reactstrap";

const MessageDetails = ({ notification, allLoginCustomer, isReplyOpen }) => {

    return (
        <div className="mt-4">
            {isReplyOpen && (
                <Card className="shadow-sm border-0" style={{ backgroundColor: "#f9f9f9" }}>
                    <CardBody>
                        {notification.MessageType === "RequestFootage" &&
                            <CardTitle tag="h6" className="fw-bold mb-2 text-primary">
                                Request Footage
                            </CardTitle>}

                        <CardText className="mb-1">
                            <strong>Contact Person:</strong> {notification.contactPerson}
                        </CardText>
                        {notification.phoneNumber && <CardText className="mb-1">
                            <strong>Phone Number:</strong> {notification.phoneNumber}
                        </CardText>}

                        {notification.email && <CardText className="mb-1">
                            <strong>Email:</strong> {notification.email}
                        </CardText>}

                        {notification.siteAddress && <CardText className="mb-1">
                            <strong>Site Address:</strong> {notification.siteAddress}
                        </CardText>}

                        {notification.cameraNumber && <CardText className="mb-1">
                            <strong>Camera Number:</strong> {notification.cameraNumber}
                        </CardText>}
                        <CardText className="mb-1">
                            <strong>Message:</strong> {notification.messageContent}
                        </CardText>

                        <CardText className="mb-1">
                            <strong>Replies:</strong> {notification.replies.length}
                        </CardText>
                    </CardBody>
                </Card>
            )}
        </div>
    );
};

export default MessageDetails;
